/**
 * Ticker — the thin "LIVE FROM PORTLAND, OR · 14:32 PDT · CH 00 · HOME …"
 * strip under the hero. A broadcast chyron; updates the clock once a
 * second and the channel whenever ChannelSurf flashes its OSD.
 */
export class Ticker {
  constructor(host, { channelSurf = null } = {}) {
    this.el = document.createElement('div');
    this.el.className = 'ticker';
    this.el.setAttribute('aria-hidden', 'true');
    this.el.innerHTML = '<div class="ticker__live"><i></i>live</div><div class="ticker__track"><span class="ticker__text"></span><span class="ticker__text"></span></div>';
    host.appendChild(this.el);
    this.cs = channelSurf;
    this.items = {
      from: 'Live from Portland, OR',
      ch: 'CH 00 · HOME',
      note: 'Available for contract work — seanburles@gmail.com',
      keys: 'Remote: 1–4 worlds · 9 on air · 0 home',
    };
    this._render();
    setInterval(() => this._render(), 1000);
    if (channelSurf) {
      const origShow = channelSurf.show.bind(channelSurf);
      channelSurf.show = (ch, name, opts) => { this.items.ch = `${ch} · ${name || ''}`.toUpperCase(); this._render(); return origShow(ch, name, opts); };
    }
  }

  _render() {
    const now = new Date();
    const time = now.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false, timeZone: 'America/Los_Angeles' }) + ' PT';
    const text = [this.items.from, time, this.items.ch, this.items.note, this.items.keys].join('   ◆   ') + '   ◆   ';
    this.el.querySelectorAll('.ticker__text').forEach((s) => { if (s.textContent !== text) s.textContent = text; });
  }
}
